<div *ngIf="visibility" class="cand-modal">
    <article *ngIf="content" class="cand-modal__overlay cand-modal__overlay--loader">
        <section class="cand-modal__content" [ngClass]="{ 'cand-modal__content--success': success }">
            <span class="loader" [ngClass]="{ 'loader--spinner': !success, 'loader--success': success }"></span>
            <p>{{ content | i18n }}</p>
        </section>
    </article>
    <div class="cand-modal__fade"></div>
</div>
